import { JobType } from './types'

export const getRoleTypeFirstName = (jobType: JobType) => {
  switch (jobType) {
    case JobType.Type1:
      return '一轉'
    case JobType.Type2:
    case JobType.Type2s:
      return '二轉'
    default:
      return ''
  }
}

/**
 * 按鈕配置
 */
export const jobSwitchBtnConfig = [
  {
    className: 'btn-1',
    jobType: JobType.Type1,
  },
  {
    className: 'btn-2',
    jobType: JobType.Type2,
  },
  {
    className: 'btn-2s',
    jobType: JobType.Type2s,
  },
]

export const jobSwitchBtnConfigV2 = [
  {
    className: 'btn-1',
    jobType: JobType.Type1,
  },
  {
    className: 'btn-2',
    jobType: JobType.Type2,
  },
  {
    className: 'btn-22',
    jobType: JobType.Type22,
  },
  {
    className: 'btn-2s',
    jobType: JobType.Type2s,
  },
  {
    className: 'btn-2s2',
    jobType: JobType.Type2s2,
  },
]

const loadOneImg = (url: string) => {
  const img = new Image()
  img.src = url
}

export const changeImgUrlToLocal = (url = '') => {
  let result
  try {
    result =
      new URL(`../../../pages/hmt/reservation/official-site/imgs/page6/public/${url}`, import.meta.url).href
  } catch (error) {
    result = ''
  }
  return result
}

export const loadImg = (url: string | string[]) => {
  if (Array.isArray(url)) {
    url.forEach((item) => loadOneImg(changeImgUrlToLocal(item)))
    return
  }
  loadOneImg(url)
}
